/* Magic Milk - Schriften zusammenlegen.
   Setzt Design-Grundregel 3 um: HOECHSTENS 2-3 Schriftarten.

   Mert, 21.08.2026, zum TikTok-Karussell mit den fuenf Design-Grundregeln:
   "Diese Sachen fuer immer speichern, was so Design angeht, Seitenaufbau,
   Struktur und so weiter, diese Regel ist fest, das muss immer sein." und
   "diese Regel in alle aktuellen Projekte anpassen ... in alte und auch
   aktuelle anpassen, neu anpassen bedeutet updaten."
   Regelwerk: ~/.claude/skills/design-dna/grundregeln/GRUNDREGELN.md

   GEMESSEN auf der Startseite vor dem Eingriff: **14 Schriftfamilien**
   Poppins 1350 · DM Sans 1074 · Barlow Condensed 405 · Bebas Neue 193 ·
   Times 78 · Manrope 73 · Inter-SemiBold 57 · Josefin Sans 56 ·
   MM Vaseline 11 · Raleway 11 · Arial 11 · Passion One 3 · Protest Riot 2

   Welche drei bleiben - nicht geraten, gemessen:
   - **Barlow Condensed** traegt ALLE neun grossen Ueberschriften (40/36/32/30/
     28/25 px). Das ist die Anzeigeschrift des Shops.
   - **DM Sans** ist die Fliesstextschrift aus den Theme-Einstellungen.
   - **MM Vaseline** ist Merts eigene Schrift, bewusst als Akzent gesetzt.
   Alles andere kommt aus Apps (Sternify, Shogun, Bewertungs-Widgets) und ist
   nicht gewollt.

   WIE es umgesetzt ist: Man kann in CSS nicht nach der berechneten Schrift
   auswaehlen. Darum werden die fremden Familien per @font-face **umdefiniert** -
   wer "Josefin Sans" anfordert, bekommt die DM-Sans-Datei des Shops. Das
   greift auch in App-Markup, das ich nicht anfassen kann, und ueberlebt
   App-Updates.

   NICHT angefasst: revicons, FontAwesome, Pe-icon-7-stroke. Das sind
   Symbolschriften - wer sie umbiegt, macht aus Symbolen Buchstabensalat. */
(function () {
  var CDN = 'https://magicmilk.de/cdn/fonts/';

  /* Dateien, die der Shop ohnehin schon laedt. */
  var ANZEIGE = CDN + 'barlow_condensed/barlowcondensed_n6.30a391fe19ded5366170913f031e653a88992edc.woff2';
  var TEXT    = CDN + 'dm_sans/dmsans_n4.ec80bd4dd7e1a334c969c265873491ae56018d72.woff2';

  /* fremde Familie -> welche der drei sie ersetzt */
  var AUF_ANZEIGE = [
    'Bebas Neue', 'Passion One', 'Protest Riot', 'Titan One',
    'Francois One', 'Bayon', 'Archivo', 'Anton'
  ];
  var AUF_TEXT = [
    'Poppins', 'Josefin Sans', 'Raleway', 'Inter-SemiBold', 'Inter',
    'OpenSans', 'Open Sans', 'Caveat', 'Manrope', 'Lato', 'Montserrat'
  ];

  function umbiegen(familie, datei) {
    /* font-weight 100 900: eine Datei deckt alle Schnitte ab, der Browser
       rechnet Fett selbst. Ohne diese Zeile faellt die Anfrage nach 700
       auf die naechste Schrift im Stapel zurueck - und dann waere wieder
       eine vierte Familie im Spiel. */
    return '@font-face{font-family:"' + familie + '";' +
           'src:url("' + datei + '") format("woff2");' +
           'font-weight:100 900;font-style:normal;font-display:swap}';
  }

  /* 21.08.2026: Mert hat im Schriftarten-Portal **Poppins ExtraBold** fuer die
     Ueberschrift "OVER 10.000+ PEOPLE TRUST US" gewaehlt.
     Haken dabei: Poppins wird oben absichtlich auf DM Sans umgebogen (es kam
     aus den Apps und war eine der 14 Schriften). Wuerde ich die Umbiegung
     aufheben, kaeme Poppins auf 1350 Stellen zurueck.
     Loesung: ein EIGENER Familienname auf dieselbe Datei. So bekommt genau
     diese eine Ueberschrift echtes Poppins, ueberall sonst bleibt es bei
     DM Sans. Damit sind es weiterhin drei Schriften im Fliesstext plus diese
     eine bewusste Ausnahme, die Mert selbst gesetzt hat. */
  var POPPINS = CDN + 'poppins/poppins_n6.aa29d4918bc243723d56b59572e18228ed0786f6.woff2';

  /* 22.08.2026, Mert: "ich brauch ein schriftart was unuebersehbar ist und am
     besten rote pinke schriftart". Gewaehlt: ANTON - dieselbe Schrift wie auf
     der Magic-Fruit-Verpackung, massiv und laut.
     WICHTIG: "Anton" steht in AUF_ANZEIGE und wird dort absichtlich auf Barlow
     Condensed umgebogen (es kam aus den Apps). Wuerde ich das aufheben, kaeme
     Anton ueberall zurueck. Darum ein EIGENER Familienname auf die eigene
     Datei - genau derselbe Kniff wie bei "MM Poppins". Die Datei liegt im
     Theme (`assets/mm-anton.woff2`, 57 kB), nicht bei Google. */
  var ANTON = 'https://magicmilk.de/cdn/shop/t/28/assets/mm-anton.woff2';

  /* 22.08.2026: Mert hat im Schriftarten-Portal **Kids Magazine** gewaehlt
     ("mehr in die comic fruity richtung"). Eine seiner eigenen 27 Schriften,
     8 kB als woff2. Anton lag davor kurz drin und war ihm "nicht modern" -
     die Deklaration bleibt stehen, die Schrift ist damit weiter verfuegbar,
     wird aber nirgends mehr benutzt. */
  var KIDS = 'https://magicmilk.de/cdn/shop/t/28/assets/mm-kidsmagazine.woff2';
  /* 22.08.2026: Mert "text schriftart aendern" - Kids Magazine raus, LUCKIEST
     GUY rein. Auch aus seinem eigenen Bestand, klarer lesbar, gleiche
     Comic-Richtung. Kids Magazine bleibt als "MM Kids" verfuegbar. */
  var LAUT = 'https://magicmilk.de/cdn/shop/t/28/assets/mm-laut.woff2';

  var regeln = [];
  regeln.push('@font-face{font-family:"MM Laut";' +
              'src:url("' + LAUT + '") format("woff2");' +
              'font-weight:400 900;font-style:normal;font-display:swap}');
  regeln.push('@font-face{font-family:"MM Kids";' +
              'src:url("' + KIDS + '") format("woff2");' +
              'font-weight:400 900;font-style:normal;font-display:swap}');
  regeln.push('@font-face{font-family:"MM Anton";' +
              'src:url("' + ANTON + '") format("woff2");' +
              'font-weight:400 900;font-style:normal;font-display:swap}');
  regeln.push('@font-face{font-family:"MM Poppins";' +
              'src:url("' + POPPINS + '") format("woff2");' +
              'font-weight:100 900;font-style:normal;font-display:swap}');
  /* 22.08.2026: Die neue Ueberschrift "NEUTRAL ODER ERDBEERE" steht in
     "MM Poppins" mit Gewicht 800. Die Datei oben ist aber nur poppins_n6
     (600) - der Browser haette das Fett dazugerechnet und es waere bei
     5 rem matschig geworden. Der Shop liefert auch poppins_n7; die zweite
     Deklaration deckt genau den schweren Bereich mit einer echten Datei ab.
     Keine neue Schriftfamilie - dieselbe, nur ein echter Schnitt mehr. */
  regeln.push('@font-face{font-family:"MM Poppins";' +
              'src:url("' + CDN + 'poppins/poppins_n7.56758dcf284489feb014a026f3727f2f20a54626.woff2") format("woff2");' +
              'font-weight:700 900;font-style:normal;font-display:swap}');

  AUF_ANZEIGE.forEach(function (f) { regeln.push(umbiegen(f, ANZEIGE)); });
  AUF_TEXT.forEach(function (f) { regeln.push(umbiegen(f, TEXT)); });

  /* Times und Arial haben kein @font-face - sie entstehen dort, wo ein Element
     gar keine Schrift setzt und auf den Browserstandard faellt. Ein Erbwert
     auf dem Hauptbereich faengt genau diese Faelle ab, ohne Elemente zu
     ueberschreiben, die eine eigene Schrift gesetzt haben. */
  regeln.push('#MainContent{font-family:"DM Sans",-apple-system,BlinkMacSystemFont,sans-serif}');

  /* 21.08.2026, Mert zu "4 Sorten, ein Ziel.": "mach textschrift art design
     hier wie davor!"
     Ursache: Die Sternify-Karten fordern Poppins an, und Poppins wird oben
     auf DM Sans umgebogen. Dadurch stand die Zeile ploetzlich in der
     Fliesstextschrift statt in der Anzeigeschrift - sie sah neutral aus.
     Die Kartentitel bekommen die Anzeigeschrift des Shops zurueck. Das
     bleibt innerhalb der drei erlaubten Schriften, es ist dieselbe, die
     alle grossen Ueberschriften tragen. */
  regeln.push('.st_card_title,.st_card_title-mobile,.st_card_title p,' +
              '.st_card_title-mobile p{' +
              'font-family:"Barlow Condensed","DM Sans",sans-serif!important;' +
              'font-weight:800!important;letter-spacing:-.01em}');

  /* GEMESSENER FEHLVERSUCH, 21.08.2026: Der Block stand zuerst GANZ VORNE im
     Kopf - das war falsch herum. Bei zwei @font-face fuer dieselbe Familie,
     dasselbe Gewicht und denselben Stil gewinnt die ZULETZT deklarierte.
     Die App-Stilblaetter laden spaeter und haben meinen Block ueberschrieben:
     Poppins, Manrope, Inter und Caveat lagen richtig, aber Bebas Neue,
     Passion One, Protest Riot, Titan One, Francois One, Bayon, Archivo,
     Josefin Sans und Raleway blieben unveraendert.
     Also: ans ENDE haengen - und nach jedem spaeter eingefuegten Stilblatt
     erneut ans Ende schieben. */
  var block = null;

  function setzen() {
    var kopf = document.head || document.documentElement;
    if (!block) {
      block = document.createElement('style');
      block.id = 'mmTypo-stil';
      block.textContent = regeln.join('');
    }
    /* immer als letztes Kind - auch beim Nachziehen */
    if (block.parentNode !== kopf || kopf.lastChild !== block) {
      kopf.appendChild(block);
    }
  }

  setzen();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setzen);
  }
  window.addEventListener('load', setzen);

  /* Apps schieben ihre Stilblaetter teils lange nach dem Laden nach.
     Der Beobachter schiebt meinen Block dann wieder ans Ende. Er laeuft
     nicht ewig: nach 15 Sekunden ist Schluss, danach kommt nichts mehr. */
  /* Die Ueberschrift wird ueber ihren TEXT gefunden, nicht ueber eine
     App-Klasse - Klassennamen aendern sich beim naechsten App-Update, der
     Text nicht. */
  function poppinsSetzen() {
    var alle = document.querySelectorAll('#MainContent h1,#MainContent h2,#MainContent h3,#MainContent p,#MainContent span,#MainContent div');
    for (var i = 0; i < alle.length; i++) {
      var e = alle[i];
      if (e.children.length > 1) continue;
      var t = (e.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 60) continue;
      if (!/PEOPLE\s+TRUST\s+US/i.test(t)) continue;
      e.style.setProperty('font-family', '"MM Poppins", "DM Sans", sans-serif', 'important');
      e.style.setProperty('font-weight', '800', 'important');
      e.style.setProperty('letter-spacing', '-.01em', 'important');
    }
  }
  poppinsSetzen();
  window.addEventListener('load', poppinsSetzen);
  setTimeout(poppinsSetzen, 1200);
  setTimeout(poppinsSetzen, 3000);

  if (window.MutationObserver) {
    var wache = new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        var neue = aenderungen[i].addedNodes;
        for (var k = 0; k < neue.length; k++) {
          var n = neue[k];
          if (n !== block && n.nodeType === 1 &&
              (n.tagName === 'STYLE' || n.tagName === 'LINK')) {
            setzen();
            return;
          }
        }
      }
    });
    wache.observe(document.head || document.documentElement, { childList: true });
    setTimeout(function () { wache.disconnect(); }, 15000);
  }
})();
